// extracted by mini-css-extract-plugin
export default {"successToast":"ccf-alert_successToast__5vTVe","successTick":"ccf-alert_successTick__AXXCN","closeIcon":"ccf-alert_closeIcon__OzDmy"};